import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import Feature from "ol/Feature";
import { LineString } from "ol/geom";
import { fromLonLat } from "ol/proj";
import { lineString, point } from "@turf/helpers";
import nearestPointOnLine from "@turf/nearest-point-on-line";
import { toLatLon } from "../util";

export function getHoverLayer(styleFunction) {
  const vectorSource = new VectorSource({});
  const vectorLayer = new VectorLayer({
    source: vectorSource,
    style: styleFunction,
  });
  vectorLayer.setZIndex(100);

  return vectorLayer;
}

// Build a 2-point "tangent" LineString from the point before the
// closest-on-line to the closest-on-line itself, in EPSG:3857 so it can go
// straight into a hover layer. Copies all non-geometry properties from the
// source feature so hover-style functions can read them.
//
// Returns `{ tangent, latLonGeometry, closestPointLatLon }` — callers that
// need `distanceAlongCm` (e.g. FeatureInfoControl for LR decoding at cursor)
// can reuse the intermediate lat/lon results. Returns null if the source
// isn't a LineString.
export function buildTangentFeature(sourceFeature, position) {
  const geometry = sourceFeature.getGeometry();
  if (!geometry || geometry.getType() !== "LineString") return null;

  const latLonGeometry = toLatLon(
    lineString(geometry.getCoordinates()).geometry,
  );
  const latLonEventPoint = toLatLon(point(position).geometry);
  const closestPointLatLon = nearestPointOnLine(
    latLonGeometry,
    latLonEventPoint,
  );
  const idx = closestPointLatLon.properties.index;
  const beforeCoord = latLonGeometry.coordinates[idx];
  const closestCoord = closestPointLatLon.geometry.coordinates;

  const tangent = new Feature({
    geometry: new LineString([
      fromLonLat(beforeCoord),
      fromLonLat(closestCoord),
    ]),
  });
  sourceFeature.getKeys().forEach((key) => {
    if (key !== "geometry") tangent.set(key, sourceFeature.get(key));
  });
  return { tangent, latLonGeometry, closestPointLatLon };
}
